<lb-two-column-page-layout>
	<ng-container two-column-page-layout-left-content>
		@if (!isEnrollmentsLoading()) {
			<div class="schedule-info-panel">
				<md-content-box class="info-card">
					<div class="heading">
						<div class="icon">
							<md-icon icon="untitled-ui/general/translate-01"></md-icon>
						</div>
						<md-header size="sm" variant="semibold">{{ currentEnrollmentHistory()?.languageName }}</md-header>
						<div class="subheader">Level {{ currentEnrollment()?.languageLevelDisplayName }}</div>
					</div>
					<div class="details">
						<div class="description">{{ currentEnrollmentHistory()?.programName }}</div>
					</div>
				</md-content-box>
				<lrnr-scheduler-progress></lrnr-scheduler-progress>
				@if (currentStepIndex() === 1) {}
			</div>
		} @else {
			<lb-loader></lb-loader>
		}
	</ng-container>

	<ng-container two-column-page-layout-right-content>
		<ng-container *ngComponentOutlet="$any(currentSchedulerStep().stepComponent)"></ng-container>

		<div class="button-container">
			@if (!isFirstStep()) {
				<button md-button-brand (click)="goToPreviousStep()" class="back-button" [disabled]="submitting()">
					<md-icon icon="untitled-ui/arrows/arrow-narrow-left"></md-icon>
					Back
				</button>
			}

			@if (isLastStep()) {
				<button
					md-button-brand
					(click)="completeSchedulerStep()"
					[disabled]="!canFinish() || submitting()"
					[md-tooltip]="finishButtonTooltip()"
					[md-tooltip-disabled]="canFinish()"
				>
					@if (submitting()) {
						<lb-loader size="small"></lb-loader>
					} @else {
						Submit
					}
				</button>
			} @else {
				<button
					md-button-brand
					[disabled]="!canProceedToNextStep()"
					(click)="goToNextStep()"
					[md-tooltip]="nextButtonTooltip()"
					[md-tooltip-disabled]="canProceedToNextStep()"
				>
					Next
					<md-icon icon="untitled-ui/arrows/arrow-narrow-right"></md-icon>
				</button>
			}
		</div>
	</ng-container>
</lb-two-column-page-layout>
